import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import AuthGuard from "@/components/feature/admin/AuthGuard";
import AdminLayout from "@/components/feature/admin/AdminLayout";
import AdminLogin from "@/pages/admin/login/page";
import AdminContacts from "@/pages/admin/contacts/page";
import AdminEmailSettings from "@/pages/admin/settings/email/page";
import AdminMedia from "@/pages/admin/media/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: (
      <AuthGuard>
        <AdminLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/admin/contacts" replace />,
      },
      {
        path: "contacts",
        element: <AdminContacts />,
      },
      {
        path: "settings/email",
        element: <AdminEmailSettings />,
      },
      {
        path: "media",
        element: <AdminMedia />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;